module.exports = __webpack_public_path__ + "img/Straight-Knee-Boots.8071df0d.jpg";